import router from '../../../router'
import { SortedTable, SortLink } from 'vue-sorted-table'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputText from '../../../components/input-text/InputText'
import InputButton from '../../../components/input-button/InputButton'
import InputDropdownFilter from '../../../components/input-dropdown-filter/InputDropdownFilter'
import Loader from '../../../components/loader/Loader'
import SettingsHeader from '../../../components/settings-header/SettingsHeader'
import { GroupService, Group } from '../../../services/group.service'
import { Constants } from '../../../constants'
import { ScreenLoader } from '../../../utils/loading.util'
import {CustomerService} from "@/services/customer.service";
import customer from "@/views/settings/customer/customer";

export default {
    name: 'Group',
    components: {
        NavigationBar,
        TabBar,
        InputText,
        InputDropdownFilter,
        InputButton,
        Loader,
        SettingsHeader,
        SortedTable,
        SortLink,
    },

    data() {
        return {
            group: new Group(),
            entities: [],
            customers: [],
            customerEntityMap: new Map(),
            screenLoader: new ScreenLoader()
        }
    },

    async mounted() {
        await this.getData()
    },

    methods: {
        doClear(reference) {
            this.group[reference] = ''
        },

        doSave() {
            // TODO: When POST and PUT are available
        },

        doCancel() {
            router.push(`/settings/groups`)
        },
        doAddNewEntity(id){
            router.push(`/settings/groups/group/entity?id=${undefined}&groupId=${id}`)

        },

        selectRow(entity, groupId) {
            router.push(`/settings/groups/group/entity?id=${entity.id}&groupId=${groupId}`)
        },

        getData: async function() {
            await Promise.all([
                GroupService.getGroup(this.$route.params.id),
                CustomerService.getCustomers()
            ]).then((response) => {
                this.handeResponse(response)
            }).catch((error) => {
                this.screenLoader.stopWithError(error)
            })
        },

        createGroup: async function() {
            // TODO: When POST and PUT are available
        },

        updateGroup: async function() {
            // TODO: When POST and PUT are available
        },

        handeResponse(response) {
            this.group = new Group(response[0])
            this.customers = response[1]

            this.group.entities.forEach((entity) => {
                const customers = this.customers.filter(customer => {
                    const entities = customer.locations.flatMap(location => location.entities).map(e => e.id)
                    return entities.includes(entity.id)
                })

                this.customerEntityMap.set(entity.id, customers.map(cust => cust.name))
            })
            this.screenLoader.stop(['groups'])
        },

        handleMutateGroupResponse(response, message) {
            // TODO: When POST and PUT are available
        },

        removeEntity(id) {
            // TODO:  When POST and PUT are available
        },

        getCustomerForEntity(entity) {
            return this.customerEntityMap.get(entity.id).join(', ')
        }
    }
}
